import { memo } from 'react';
import { Header, IconHighlight } from '@aimsos/ui';
import { Users } from 'lucide-react';
import { useTranslation } from '@aimsos/i18n';

import PeopleAccessTabs from './PeopleAccessTabs';

/**
 * Title (+ optional actions) and the Members / Roles / Groups tabs shared by the three list
 * screens. The layout renders it whole by default. A list page that pins only the title and its
 * buttons (the Members list) takes the header over (see `useOwnPeopleAccessHeader`), renders this
 * with `showTabs={false}` inside its sticky band and places `PeopleAccessTabs` below it, so the tabs
 * scroll away with the content.
 *
 * @param {object} props
 * @param {'M'|'compress'} [props.size='M'] `compress` is the pinned, scrolled state.
 * @param {import('react').ReactNode} [props.actions] Right side of the title row (a node, as `Header` allows).
 * @param {boolean} [props.showTabs=true]
 */
function PeopleAccessHeader({ size = 'M', actions, showTabs = true }) {
  const { t } = useTranslation('people-access');

  return (
    <div className="flex flex-col gap-4">
      <Header
        size={size}
        showIcon
        icon={<IconHighlight icon={Users} bgColor="Primary" iconColor="PrimaryAlt" size="small" />}
        title={t('app.title')}
        titleClassName="!text-lg !font-semibold"
        showBackButton={false}
        showDescription={false}
        showTag={false}
        showPrimaryCta={Boolean(actions)}
        primaryCta={actions}
      />
      {showTabs ? <PeopleAccessTabs /> : null}
    </div>
  );
}

export default memo(PeopleAccessHeader);
